import { Box, Flex, Image, Skeleton, Text } from "@chakra-ui/react";
import {
  useAreasComum,
  useFindAreaComum,
} from "core/features/area-comum/hooks";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import colors from "core/resources/theme/colors";
import { formatAreaComumValor } from "infra/helpers/formatAreaComumValor";
import { useState } from "react";
import CardDefault from "ui/components/Cards/CardDefault";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Pagination from "ui/components/Pagination";
import { SimpleGrid } from "@chakra-ui/layout";

function FormAreaComum({ value, onChange }: { value: any; onChange: any }) {
  const [page, setPage] = useState(1);
  const { tenant } = useCurrentTenant();
  const { data, isLoading } = useAreasComum(tenant.id, {
    page,
    limit: 8,
    ativo: true,
  });

  const { data: areaComum, isFetching: isFetchingImagens } = useFindAreaComum(
    tenant.id,
    value
  );

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
  };

  return (
    <>
      {isLoading ? (
        <SimpleGrid columns={2} gridGap={2} w="100%" px={4}>
          <Skeleton rounded={"8px"} w="100%" h="130px" my={1} />
          <Skeleton rounded={"8px"} w="100%" h="130px" my={1} />
          <Skeleton rounded={"8px"} w="100%" h="130px" my={1} />
          <Skeleton rounded={"8px"} w="100%" h="130px" my={1} />
        </SimpleGrid>
      ) : null}

      <Box w="100%">
        <SimpleGrid columns={2} gridGap={2} w="100%" px={4}>
          {data?.items?.map((item, index) => (
            <CardDefault
              borderWidth={"1px"}
              borderStyle={"solid"}
              my={1}
              borderColor={item.id === value ? colors.primary : "transparent"}
              onClick={() => onChange(item.id)}
              title={item.nome}
            >
              <Flex
                flexDir={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                height="100%"
              >
                <Text
                  fontWeight={"bold"}
                  textAlign="center"
                  noOfLines={2}
                  height={"48px"}
                >
                  {item.nome}
                </Text>
                <Text color={colors.primary} mt="auto">
                  {formatAreaComumValor(
                    item.valor,
                    item.valorMinimo,
                    item.valorMaximo
                  )}
                </Text>
              </Flex>
            </CardDefault>
          ))}
        </SimpleGrid>
        <Pagination
          style={{ marginTop: 16, marginLeft: "auto", marginRight: 24 }}
          current={data?.meta.currentPage ?? 1}
          total={data?.meta.totalItems ?? 0}
          pageSize={data?.meta.itemsPerPage ?? 0}
          hideOnSinglePage
          onChange={(page, pageSize) => {
            setPage(page);
          }}
        />
      </Box>

      {isFetchingImagens ? (
        <Flex gap="24px" my="16px">
          <Skeleton rounded={"8px"} w="160px" h="80px" />
          <Skeleton rounded={"8px"} w="160px" h="80px" />
          <Skeleton rounded={"8px"} w="160px" h="80px" />
          <Skeleton rounded={"8px"} w="160px" h="80px" />
          <Skeleton rounded={"8px"} w="160px" h="80px" />
        </Flex>
      ) : null}

      {areaComum && areaComum?.imagens.length ? (
        <Box mt="32px" mb="16px">
          <Text fontSize={"22px"} my="16px">
            Fotos do espaço
          </Text>

          <Box>
            <Slider {...settings}>
              {areaComum?.imagens.map((item, index) => (
                <Box
                  opacity={0.8}
                  pr="16px"
                  _hover={{ opacity: 1 }}
                  key={index}
                >
                  <Zoom>
                    <Image
                      w="100%"
                      h="130px"
                      src={item.url}
                      alt="Imagem da área comum"
                      objectFit="cover"
                    />
                  </Zoom>
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>
      ) : null}
    </>
  );
}

export default FormAreaComum;
